// Sanitise a value into a positive integer string within a range.
// - Strips all non-digits
// - Removes leading zeros via parseInt
// - Clamps to [min, max]
// - Returns '' if input is empty or cannot be parsed

export default function sanitisePositiveInt(value, min = 1, max = 9999) {
  let v = value ?? ''
  v = String(v).replace(/[^0-9]/g, '')

  if (v === '') {
    return ''
  }

  let num = parseInt(v, 10)
  if (Number.isNaN(num)) return ''

  if (num < min) num = min
  if (num > max) num = max

  return String(num)
}
